const extractor = (data) => {
    return [...data.matchAll(/img.*?src="(.*?)"/gm)]
        .map((el) => {
            return el[1] && el[1].includes('data:') ? el[1] : [];
        })
        .filter((array) => array.length);
};

export default extractor;
